<template>
  <div>
    <div id="modals-container"></div>
    <add-associate ref="addAssociate"
      @success="refreshAssociates"></add-associate>
    <edit-associate ref="editAssociate"
      @successEdit="refreshAssociates"></edit-associate>

    <v-container>
      <v-row class="justify-center">
        <v-col cols="12" sm="11" lg="11" class="px-0">

          <!-- Sticky header -->
          <div class="associates-sticky-header">
            <div class="controls-row">
              <v-text-field
                v-model="searchTerm"
                placeholder="Pretraži klijente"
                dense
                outlined
                hide-details
                clearable
                class="filter-select controls-search"
                prepend-inner-icon="mdi-magnify"
                @input="onSearchInput"
                @click:clear="clearSearch"
                @keyup.enter="applySearch"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn elevation="0" class="add-associate-btn" @click="addAssociate">
                <v-icon left small>mdi-plus</v-icon>
                Dodaj klijenta
              </v-btn>
            </div>
            <div class="associates-thead">
              <div style="width:4%;"></div>
              <div class="associates-thead-cell" style="width:46%;">Naziv klijenta</div>
              <div class="associates-thead-cell hidden-sm-and-down" style="width:15%;">OIB</div>
              <div class="associates-thead-cell hidden-md-and-down" style="width:20%;">Adresa</div>
              <div class="associates-thead-cell" style="width:10%;">Status</div>
              <div style="width:5%;"></div>
            </div>
          </div>

          <!-- Rows -->
          <v-expansion-panels focusable class="assoc-panels-body">
            <v-expansion-panel
              v-for="(item, i) in currentAssociates"
              :key="i"
              :class="['assoc-panel', getRowClass(item.status)]"
            >
              <v-expansion-panel-header
                hide-actions
                class="assoc-row-header"
              >
                <div class="assoc-row-inner">
                  <div class="expand-icon-wrap" style="width:4%;">
                    <v-icon size="18" color="#94A3B8">mdi-chevron-right</v-icon>
                  </div>

                  <!-- Name -->
                  <div class="assoc-cell assoc-name" style="width:46%; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                    {{ item.name }}
                  </div>

                  <!-- OIB -->
                  <div class="assoc-cell hidden-sm-and-down" style="width:15%;">
                    <span v-for="(oib, oi) in item.oibs" :key="oi">{{ oib }}</span>
                  </div>

                  <!-- Address -->
                  <div class="assoc-cell hidden-md-and-down text-truncate" style="width:20%;">
                    {{ item.address }}
                  </div>

                  <!-- Status -->
                  <div class="assoc-cell" style="width:10%;">
                    <v-chip x-small :class="getStatusChipClass(item.status)">
                      {{ showStatus(item.status) }}
                    </v-chip>
                  </div>

                  <!-- Actions kebab -->
                  <div class="assoc-cell-actions" style="width:5%;">
                    <v-menu bottom left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
                          <v-icon size="18" color="#94A3B8">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="editAssociate(item)">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="#3989C9">mdi-pencil</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Uredi</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="confirmDeleteAssociate(item)">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="#F44336">mdi-delete</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Obriši</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="assoc-detail-content">
                <div class="assoc-detail-inner">
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <div class="detail-section-title">Adresa</div>
                      <div class="detail-data text-capitalize">{{ item.address }}</div>
                      <div class="detail-data text-capitalize">{{ item.zip_code }} {{ item.city }}</div>
                      <div class="detail-data text-capitalize">{{ item.country }}</div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="detail-section-title">Kontakt</div>
                      <div class="detail-data"><span class="detail-label">Email:</span> {{ item.email }}</div>
                      <div class="detail-data"><span class="detail-label">Telefon:</span> {{ item.phone }}</div>
                      <div class="detail-data"><span class="detail-label">Mobitel:</span> {{ item.mobile }}</div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="detail-section-title">Dodatno</div>
                      <div class="detail-data"><span class="detail-label">Šifra:</span> {{ item.code }}</div>
                      <div class="detail-data"><span class="detail-label">Web:</span> {{ item.web }}</div>
                      <div class="detail-data"><span class="detail-label">IBAN:</span> {{ item.ibans && item.ibans.length > 0 ? item.ibans[0] : '' }}</div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="detail-section-title">Pregled</div>
                      <div class="assoc-link mb-2" @click="receiptOffer('receipts', item.oibs[0])">
                        <v-icon small color="#00838F" class="mr-1">mdi-file-document-outline</v-icon>
                        Računi
                      </div>
                      <div class="assoc-link" @click="receiptOffer('offers', item.oibs[0])">
                        <v-icon small color="#00838F" class="mr-1">mdi-file-chart-outline</v-icon>
                        Ponude
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Pagination — ispod tablice -->
          <div v-if="currentAssociates.length > 0 || hasMore" class="pagination-row">
            <v-btn
              class="page-nav-btn"
              :disabled="!hasPrevPage || isLoading"
              @click="prevPage"
              small
            >
              <v-icon small class="mr-1">mdi-chevron-left</v-icon>
              Prethodni
            </v-btn>
            <span class="page-indicator">Stranica {{ currentPage }}</span>
            <v-btn
              class="page-nav-btn"
              :disabled="!hasNextPage || isLoading"
              @click="nextPage"
              small
            >
              Sljedeći
              <v-icon small class="ml-1">mdi-chevron-right</v-icon>
            </v-btn>
          </div>

        </v-col>
      </v-row>
      <modal height="auto"
        width="80%"
        scrollable
        draggable
        resizable
        style="z-index: 200"
        name="receipts"
        class="myTest">
        <Receipts :receiptFilter="receiptFilter"></Receipts>
      </modal>
    </v-container>
  </div>
</template>
<script>
// import { df } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import state from '@/state'
import AddAssociate from '@/modules/company/components/AddAssociate'
import EditAssociate from '@/modules/company/components/EditAssociate'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings'
import Receipts from '@/modules/company/components/receipts/Receipts'
import EventBus from '@/plugins/event-bus'
import { callAssociates } from '@/api/associates'

export default {
  components: { AddAssociate, EditAssociate, Receipts },
  mixins: [flow, applicationSettings],
  inject: ['showLoader', 'hideLoader', 'confirm', 'confirmClose'],
  modules: { Receipts },
  data: function () {
    return {
      receiptFilter: { oibFilter: undefined, reciptOffer: undefined },
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'OIB', value: 'oib', align: 'center' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Address', value: 'address', align: 'center' },
        { text: 'Actions', value: 'id', align: 'center' }
      ],
      associates: [],
      currentAssociates: [],
      lastVisible: {},
      listeners: [],
      searchEmitDestination: 'associateSearch',
      searchTerm: '',
      debouncedSearch: null,
      isClearing: false,
      // Pagination
      isLoading: false,
      hasMore: false,
      currentPage: 1,
      nextCursor: null,
      pageCache: new Map(),
      pageCursors: [],
      itemsPerPage: 20
    }
  },
  computed: {
    hasPrevPage () {
      return this.currentPage > 1
    },
    hasNextPage () {
      return this.hasMore
    }
  },
  watch: {
    associates: {
      deep: true,
      handler (nv, ov) {
        if (nv !== ov) {
          let currentAssociates = []
          if (this.filter && this.filter !== '') {
            currentAssociates = nv.filter(associate => associate.name?.includes(this.filter.toLowerCase()) || associate.oib?.includes(this.filter.toLowerCase()))
          } else {
            currentAssociates = nv
          }
          currentAssociates = currentAssociates.filter(associate => associate.status !== '_duplicate')
          this.currentAssociates = clone(currentAssociates.sort((a, b) => a.name.localeCompare(b.name)))
        }
      }
    }
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
    // Clear debounce timer
    if (this.debouncedSearch) {
      clearTimeout(this.debouncedSearch)
    }
  },
  mounted () {
    this.getAssociates()

    EventBus.$on(this.searchEmitDestination, (searchObject) => {
      this.searchAll(searchObject.searchString)
    })
  },
  methods: {
    showStatus (status) {
      switch (status) {
        case 'OK':
          return 'Aktivan'
        case 'PROCESSING':
          return 'U obradi'
        case 'FAILED':
          return 'Neuspješan'
        default:
          return status
      }
    },
    onSearchInput () {
      // Skip if clearing is in progress
      if (this.isClearing) {
        return
      }

      // Debounce search input - wait for user to stop typing
      if (this.debouncedSearch) {
        clearTimeout(this.debouncedSearch)
      }

      // Handle null or empty value
      const searchLength = this.searchTerm ? this.searchTerm.length : 0

      // Only search if at least 3 characters are entered
      // Don't trigger on empty (length 0) as that's handled by clearSearch
      if (searchLength >= 3) {
        this.debouncedSearch = setTimeout(() => {
          this.applySearch()
        }, 500)
      }
    },
    applySearch () {
      this.searchAll(this.searchTerm)
    },
    clearSearch () {
      // Set flag to prevent onSearchInput from triggering
      this.isClearing = true
      this.searchTerm = ''

      // Clear any pending debounced search
      if (this.debouncedSearch) {
        clearTimeout(this.debouncedSearch)
      }

      // Reset pagination and search
      this.currentPage = 1
      this.pageCursors = []
      this.pageCache.clear()
      this.getAssociates()

      // Reset flag after a tick
      this.$nextTick(() => {
        this.isClearing = false
      })
    },
    refresh () {
      this.associates = []
      this.currentPage = 1
      this.pageCursors = []
      this.pageCache.clear()
      this.getAssociates()
    },
    async getAssociates (cursor = null) {
      // Check cache first
      const cacheKey = `page-${this.currentPage}-cursor-${cursor || 'start'}-search-${this.searchTerm}`
      if (this.pageCache.has(cacheKey)) {
        const cached = this.pageCache.get(cacheKey)
        this.associates = cached.associates
        this.currentAssociates = cached.currentAssociates
        this.hasMore = cached.hasMore
        this.nextCursor = cached.nextCursor
        return
      }

      this.isLoading = true
      this.showLoader()

      var path = `/associates/${state.getCurrentCompany().id}/associate`
      var params = {
        limit: this.itemsPerPage
      }

      // Add cursor for pagination
      if (cursor) {
        params.cursor = cursor
      }

      // Add search parameters - always use trigram search
      if (this.searchTerm && this.searchTerm.trim() !== '') {
        const searchValue = this.searchTerm.trim()
        params.filter = `trigram(eq:${searchValue})`
      }

      var response = await callAssociates('get', path, { params })

      this.isLoading = false
      this.hideLoader()

      if (response && response.status === 200 && response.data) {
        const responseData = response.data

        // Handle associates data
        let associatesArray = []
        if (responseData.associates) {
          associatesArray = Object.keys(responseData.associates).map(key => {
            return { ...responseData.associates[key], [`hover-${responseData.associates[key].id}`]: false }
          })
        }

        this.associates = associatesArray
        this.hasMore = responseData.has_more || false
        this.nextCursor = responseData.next_cursor || null

        // Filter and sort associates
        let currentAssociates = associatesArray.filter(associate => associate.status !== '_duplicate')
        this.currentAssociates = clone(currentAssociates.sort((a, b) => a.name.localeCompare(b.name)))

        // Cache the result
        this.pageCache.set(cacheKey, {
          associates: this.associates,
          currentAssociates: this.currentAssociates,
          hasMore: this.hasMore,
          nextCursor: this.nextCursor
        })
      } else if (response && response.status === 404) {
        this.associates = []
        this.currentAssociates = []
        this.hasMore = false
        this.nextCursor = null
      } else {
        this.showMsgBox({
          text: 'Neuspjelo dohvaćanje klijenata',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    searchAll (val) {
      // Reset pagination when searching
      this.currentPage = 1
      this.pageCursors = []
      this.pageCache.clear()
      this.getAssociates()
    },
    nextPage () {
      if (this.hasNextPage && this.nextCursor) {
        // Save current cursor for navigation back
        if (this.currentPage === this.pageCursors.length) {
          this.pageCursors.push(this.nextCursor)
        }
        this.currentPage++
        this.getAssociates(this.nextCursor)
      }
    },
    prevPage () {
      if (this.hasPrevPage) {
        this.currentPage--
        // Get cursor for previous page
        const cursor = this.currentPage === 1 ? null : this.pageCursors[this.currentPage - 2]
        this.getAssociates(cursor)
      }
    },
    receiptOffer (mode, oib) {
      this.receiptFilter.oibFilter = oib
      this.receiptFilter.reciptOffer = mode
      this.receiptFilter.modal = true
      this.$modal.show('receipts')
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].associateHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },
    addAssociate () {
      this.$refs.addAssociate.open(this.associates)
    },
    editAssociate (associate) {
      this.$refs.editAssociate.open(associate, this.associates)
    },
    confirmDeleteAssociate (associate) {
      this.confirm({
        title: 'Brisanje klijenta ',
        message: `Jeste li sigurni da želite obrisati klijenta ${associate.name}?`,
        options: {
          toolbar: true,
          width: 410,
          confirmText: 'Obriši',
          cancelText: 'Odustani'
        }
      }).then(async (resp) => {
        if (resp) {
          this.confirmClose()
          this.deleteAssociate(associate)
        } else {
          this.submitting = false
        }
      })
    },
    async deleteAssociate (associate) {
      console.log('associate', associate)
      var path = `/associates/${state.getCurrentCompany().id}/associate/${associate.id}`
      var response = await callAssociates('delete', path)

      if (response.status === 200 && response.data) {
        this.refresh()
      } else {
        this.showMsgBox({
          text: 'Neuspjelo brisanje klijenta',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    refreshAssociates () {
      this.refresh()
    },
    getRowClass (status) {
      if (status === 'OK') return 'status-ok'
      if (status === 'PROCESSING') return 'status-processing'
      return 'status-failed'
    },
    getStatusChipClass (status) {
      if (status === 'OK') return 'status-chip-ok'
      if (status === 'PROCESSING') return 'status-chip-processing'
      return 'status-chip-failed'
    }
  }
}
</script>
<style scoped>
/* Sticky header — matches Users.vue standard */
.associates-sticky-header {
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 14px 0 0;
  border-left: 3px solid #00BCD4;
  border-bottom: 1px solid #EEF2F5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.controls-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px 16px;
}

.controls-search {
  max-width: 300px;
}
.controls-search >>> .v-input__control {
  height: 40px !important;
  min-height: 40px !important;
}

/* filter-select — identical to Receipts/Users */
.filter-select { min-width: 0 !important; }

.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}
.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: #90A4AE !important;
}
.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}
.filter-select >>> .v-input__slot {
  background: #ffffff !important;
  min-height: 40px !important;
  max-height: 40px !important;
  padding: 0 8px !important;
  border-radius: 8px !important;
}
.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #263238 !important;
  letter-spacing: 0.3px !important;
}
.filter-select >>> label {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #37474F !important;
}

/* Add button — identical to Users.vue add-user-btn */
.add-associate-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 40px !important;
  min-height: 40px !important;
  white-space: nowrap;
}
.add-associate-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: none !important;
}
.add-associate-btn .v-icon {
  color: #00BCD4 !important;
  font-size: 17px !important;
}

/* Column thead */
.associates-thead {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EEF2F5;
}
.associates-thead-cell {
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  padding: 0 16px;
}

/* Pagination */
.pagination-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 0;
  border-bottom: 1px solid #EDF2F7;
}
.page-indicator {
  font-size: 13px;
  color: #718096;
  font-weight: 500;
}
.page-nav-btn {
  background: rgba(0, 188, 212, 0.06) !important;
  color: #00838F !important;
  border: 1px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  height: 30px !important;
  letter-spacing: 0.2px !important;
}
.page-nav-btn:disabled { opacity: 0.4 !important; }
.page-nav-btn .v-icon { color: #00838F !important; }

/* Rows container — grey background so margin gaps show as grey space */
.assoc-panels-body {
  background: #F5F7FA !important;
  padding: 6px 0 2px !important;
}

/* Expansion panel overrides */
.assoc-panel {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  margin-bottom: 4px !important;
  overflow: hidden !important;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease !important;
}
.assoc-panel::before { box-shadow: none !important; }

/* Row header */
.assoc-panel >>> .v-expansion-panel-header {
  padding: 0 !important;
  min-height: 60px !important;
}

/* Status border colours */
.assoc-panel.status-ok   { border-left-color: #4ADE80 !important; }
.assoc-panel.status-processing { border-left-color: #FB923C !important; }
.assoc-panel.status-failed { border-left-color: #F87171 !important; }

/* Hover on inactive panels */
.assoc-panel:not(.v-expansion-panel--active):hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.assoc-row-inner {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 10px 0;
}

.expand-icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.expand-icon-wrap .v-icon {
  transition: transform 0.25s ease;
}
.assoc-panel.v-expansion-panel--active .expand-icon-wrap .v-icon {
  transform: rotate(90deg);
}

.assoc-cell {
  padding: 0 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
}
.assoc-name {
  font-weight: 700;
  text-transform: capitalize;
}
.assoc-cell-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Status chips */
.status-chip-ok {
  background-color: #E8F5E9 !important;
  color: #2E7D32 !important;
  font-weight: 600 !important;
}
.status-chip-processing {
  background-color: #FFF3E0 !important;
  color: #E65100 !important;
  font-weight: 600 !important;
}
.status-chip-failed {
  background-color: #FFEBEE !important;
  color: #C62828 !important;
  font-weight: 600 !important;
}

/* Detail panel */
.assoc-detail-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.assoc-detail-inner {
  background: #F8FAFC;
  padding: 16px 20px 20px;
  border-top: 1px solid #EEF2F5;
}
.detail-section-title {
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 8px;
}
.detail-data {
  font-size: 13px;
  color: #475569;
}
.detail-label {
  font-weight: 500;
  color: #334155;
}

/* Pregled links */
.assoc-link {
  color: #00838F;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.15s ease;
}
.assoc-link:hover { color: #00BCD4; }

.myTest >>> .vm--modal { top: 100px !important; }
</style>
